module.exports = ".msg-error {\n  text-align: right;\n  margin-right: 160px;\n  margin-bottom: 15px; }\n"